package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.Dao
import androidx.room3.Query
import com.xtream.data_kmp.FavoriteLiveStreamEntity
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.data_kmp.dto.liveStreamsTable
import com.xtream.data_kmp.liveFavoritesTable
import kotlinx.coroutines.flow.Flow


@Dao
abstract class LiveFavDao:RoomBaseInterface<FavoriteLiveStreamEntity> {

    @Query("SELECT * FROM ${liveFavoritesTable}")
    abstract override fun allAsFlow(): Flow<List<FavoriteLiveStreamEntity>>
    @Query("SELECT * FROM ${liveFavoritesTable} ")
    abstract override fun allAsPagingSource(): PagingSource<Int, FavoriteLiveStreamEntity>


    /*
    "SELECT $liveStreamsTable.*, $liveFavoritesTable.sortOrder AS  'num' " +
            "FROM $liveStreamsTable"+
            " INNER JOIN $liveFavoritesTable ON $liveStreamsTable.streamId = $liveFavoritesTable.streamId " +
            "ORDER BY $liveFavoritesTable.sortOrder ASC" +
            " LIMIT :limit"
     */
    @Query( "SELECT ${liveStreamsTable}.*, ${liveFavoritesTable}.sortOrder AS  'num' " +
            "FROM ${liveStreamsTable}"+
            " INNER JOIN ${liveFavoritesTable} ON ${liveStreamsTable}.streamId = ${liveFavoritesTable}.streamId " +
            "ORDER BY ${liveFavoritesTable}.sortOrder ASC"
            +" LIMIT 1 OFFSET :offset"
        /*+"ORDER BY sortOrder"*/)
    abstract suspend fun getByOffset(offset: Int): LiveStream?


    @Query("SELECT EXISTS (SELECT 1 FROM ${liveFavoritesTable} WHERE streamId = :id)")

    abstract override suspend fun hasEntity(id:Int):Boolean

    @Query("SELECT EXISTS (SELECT 1 FROM ${liveFavoritesTable} WHERE streamId = :id)")

    abstract override fun hasEntityAsFlow(id:Int?):Flow<Boolean>

    @Query("SELECT COUNT(*) FROM ${liveFavoritesTable}")
    abstract override suspend fun getSize(): Long?
    @Query("""
        SELECT COUNT(*)
        FROM liveStreamsTable
        WHERE streamId IN (SELECT liveFavoritesTable.streamId FROM liveFavoritesTable)
    """)
   abstract suspend fun sizeInTvChannelsTable():Long?
    @Query("DELETE FROM liveFavoritesTable")
    abstract override suspend fun deleteAll()
}